module.exports = __webpack_public_path__ + "img/9.f1c6e8f6.jpg";